var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-5"},[_vm._v("\n    Loading your conversation...\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }